var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.14 303.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dceaf5;}.cls-2{fill:#509e70;}.cls-3{fill:#9eccb3;}.cls-4{fill:#796e33;}.cls-5{fill:#3c3b3b;}.cls-6{fill:none;stroke:#33516c;stroke-miterlimit:10;stroke-width:0.36px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.42,0A103.24,103.24,0,0,0,0,11.45v291.8c87.14-24.54,151-104.56,151.12-199.53h0A103.72,103.72,0,0,0,47.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.17,103.45a28.73,28.73,0,1,0-57.45,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.45,132.17a28.72,28.72,0,0,0,28.72-28.72H37.45S37.33,114.3,37.45,132.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.14,122.6a1.15,1.15,0,0,0,.82.34,1.13,1.13,0,0,0,.82-.34l4.2-4.2a1.18,1.18,0,0,0,0-1.65,1.16,1.16,0,0,0-1.64,0L26.11,119v-8.83a1.15,1.15,0,1,0-2.3,0V119l-2.24-2.24h0a1.16,1.16,0,0,0-1.64,0,1.15,1.15,0,0,0,0,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.71,125.22H19.21a1.15,1.15,0,0,0,0,2.29h11.5a1.15,1.15,0,0,0,0-2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.72,95.23v7.43H48v-3H44.62v3H42.9V95.23h1.72v2.93H48V95.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.24,101.28v1.38H51.48V95.23H57.1v1.38H53.19v1.61h3.45v1.34H53.19v1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M63.34,102.66l-1.43-2.07H60.33v2.07H58.61V95.23h3.21a4.16,4.16,0,0,1,1.72.32,2.6,2.6,0,0,1,1.12.94,2.57,2.57,0,0,1,.39,1.43,2.43,2.43,0,0,1-1.53,2.35l1.67,2.39ZM62.91,97a1.82,1.82,0,0,0-1.18-.33h-1.4v2.59h1.4a1.77,1.77,0,0,0,1.18-.34,1.19,1.19,0,0,0,.4-1A1.18,1.18,0,0,0,62.91,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.15,102.66l-1.43-2.07H68.13v2.07H66.41V95.23h3.22a4.08,4.08,0,0,1,1.71.32,2.63,2.63,0,0,1,1.13.94,2.57,2.57,0,0,1,.39,1.43,2.43,2.43,0,0,1-1.53,2.35L73,102.66ZM70.71,97a1.82,1.82,0,0,0-1.18-.33h-1.4v2.59h1.4a1.77,1.77,0,0,0,1.18-.34,1.2,1.2,0,0,0,.41-1A1.18,1.18,0,0,0,70.71,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79.11,101.07H75.66L75,102.66H73.24l3.31-7.43h1.7l3.33,7.43H79.77Zm-.54-1.31-1.18-2.85-1.17,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.12,102.66V98.2l-2.19,3.67h-.77L84,98.29v4.37H82.35V95.23h1.43l2.78,4.62,2.74-4.62h1.41l0,7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.5,95.23h1.72v7.43H92.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.74,101.28v1.38H96V95.23h5.62v1.38H97.69v1.61h3.45v1.34H97.69v1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.93,95.23v7.43h-1.42l-3.7-4.51v4.51h-1.7V95.23h1.42l3.7,4.51V95.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.23,96.63h-2.38v-1.4h6.48v1.4H115v6h-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.78,101.07h-3.45l-.66,1.59H116.9l3.32-7.43h1.7l3.32,7.43h-1.8Zm-.54-1.31-1.18-2.85-1.18,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.75,102.55a4.16,4.16,0,0,1-1.32-.62l.59-1.3a3.73,3.73,0,0,0,1.13.56,4.06,4.06,0,0,0,1.32.22,2.13,2.13,0,0,0,1.08-.22.65.65,0,0,0,.35-.58.57.57,0,0,0-.2-.44,1.57,1.57,0,0,0-.53-.28c-.22-.07-.51-.15-.88-.24a10.21,10.21,0,0,1-1.39-.4,2.22,2.22,0,0,1-.93-.65,1.72,1.72,0,0,1-.39-1.19,2.09,2.09,0,0,1,.35-1.17,2.37,2.37,0,0,1,1.06-.83,4.2,4.2,0,0,1,1.72-.31,5.48,5.48,0,0,1,1.4.17,3.87,3.87,0,0,1,1.19.49l-.54,1.3a4.1,4.1,0,0,0-2.06-.58,2,2,0,0,0-1.06.23.72.72,0,0,0-.35.62.61.61,0,0,0,.4.57,6.41,6.41,0,0,0,1.22.36,12.26,12.26,0,0,1,1.39.41,2.27,2.27,0,0,1,.93.63,1.76,1.76,0,0,1,.38,1.18,2,2,0,0,1-.35,1.17,2.41,2.41,0,0,1-1.07.83,4.42,4.42,0,0,1-1.73.31A6.09,6.09,0,0,1,126.75,102.55Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "113.13 83 113.13 65.67 37.46 65.67 37.46 141.34 113.13 141.34 113.13 110.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.9,106.38a1.38,1.38,0,0,1,.84,1.32,1.46,1.46,0,0,1-.22.79,1.44,1.44,0,0,1-.62.52,2.35,2.35,0,0,1-1,.18h-.83v1.14h-1V106.2h1.79A2.35,2.35,0,0,1,45.9,106.38Zm-.36,1.85a.66.66,0,0,0,.23-.53.68.68,0,0,0-.23-.54,1,1,0,0,0-.65-.18h-.78v1.43h.78A1,1,0,0,0,45.54,108.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M49.93,109.45H48l-.37.88h-1l1.84-4.13h.94l1.85,4.13h-1Zm-.3-.73L49,107.14l-.65,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.36,110.33l-.8-1.15h-.88v1.15h-1V106.2h1.79a2.33,2.33,0,0,1,.95.18,1.39,1.39,0,0,1,.62.52,1.41,1.41,0,0,1,.22.8,1.38,1.38,0,0,1-.22.79,1.46,1.46,0,0,1-.63.51l.93,1.33Zm-.24-3.17a1,1,0,0,0-.66-.18h-.78v1.44h.78a1,1,0,0,0,.66-.19.65.65,0,0,0,.22-.53A.67.67,0,0,0,54.12,107.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.78,109.45H56.87l-.37.88h-1l1.84-4.13h1l1.84,4.13h-1Zm-.3-.73-.65-1.58-.66,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.25,106.2h1.88a2.67,2.67,0,0,1,1.19.26,1.93,1.93,0,0,1,.8.72,2.17,2.17,0,0,1,0,2.17,1.93,1.93,0,0,1-.8.72,2.67,2.67,0,0,1-1.19.26H62.25Zm1.83,3.34a1.39,1.39,0,0,0,1-.34,1.37,1.37,0,0,0,0-1.87,1.39,1.39,0,0,0-1-.35h-.87v2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.32,109.56v.77H67.13V106.2h3.12V107H68.08v.89H70v.75H68.08v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.5,110.27a2.32,2.32,0,0,1-.74-.35l.33-.72a2.07,2.07,0,0,0,.63.32,2.64,2.64,0,0,0,.73.11,1.17,1.17,0,0,0,.6-.12.36.36,0,0,0,.2-.32.29.29,0,0,0-.12-.24.81.81,0,0,0-.29-.16l-.49-.13a6.41,6.41,0,0,1-.77-.22,1.35,1.35,0,0,1-.52-.36,1,1,0,0,1-.22-.67,1.18,1.18,0,0,1,.2-.65,1.27,1.27,0,0,1,.59-.46,2.44,2.44,0,0,1,1-.17,3.33,3.33,0,0,1,.78.09,2.48,2.48,0,0,1,.66.28l-.3.72a2.24,2.24,0,0,0-1.14-.32A1,1,0,0,0,72,107a.39.39,0,0,0-.2.34.33.33,0,0,0,.23.31,3.35,3.35,0,0,0,.67.21,6.41,6.41,0,0,1,.77.22,1.25,1.25,0,0,1,.52.36,1,1,0,0,1,.22.65,1.16,1.16,0,0,1-.2.65,1.33,1.33,0,0,1-.59.46,2.55,2.55,0,0,1-1,.17A3.28,3.28,0,0,1,71.5,110.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.69,110.13a2.12,2.12,0,0,1-.81-.76,2.25,2.25,0,0,1,0-2.21,2.12,2.12,0,0,1,.81-.76,2.4,2.4,0,0,1,1.14-.27,2.33,2.33,0,0,1,1,.19,1.79,1.79,0,0,1,.73.54l-.61.57a1.31,1.31,0,0,0-1-.49,1.37,1.37,0,0,0-.68.17,1.12,1.12,0,0,0-.47.47,1.47,1.47,0,0,0,0,1.37,1.12,1.12,0,0,0,.47.47,1.37,1.37,0,0,0,.68.17,1.34,1.34,0,0,0,1-.49l.61.56a1.81,1.81,0,0,1-.73.55,2.37,2.37,0,0,1-1,.19A2.4,2.4,0,0,1,75.69,110.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.81,109.45H79.9l-.37.88h-1l1.84-4.13h1l1.84,4.13h-1Zm-.3-.73-.65-1.58-.66,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.24,110.33l-.79-1.15h-.88v1.15h-1V106.2H85.4a2.3,2.3,0,0,1,.95.18,1.34,1.34,0,0,1,.84,1.32,1.38,1.38,0,0,1-.22.79,1.35,1.35,0,0,1-.63.51l.93,1.33ZM86,107.16a1,1,0,0,0-.65-.18h-.78v1.44h.78a1,1,0,0,0,.65-.19.66.66,0,0,0,.23-.53A.68.68,0,0,0,86,107.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.74,108.2h.87v1.68a2.85,2.85,0,0,1-.78.39,3,3,0,0,1-.89.13,2.41,2.41,0,0,1-1.15-.27,2.12,2.12,0,0,1-.81-.76,2.11,2.11,0,0,1,.81-3,2.52,2.52,0,0,1,1.17-.27,2.64,2.64,0,0,1,1,.18,2,2,0,0,1,.74.53l-.61.57a1.48,1.48,0,0,0-1.77-.3,1.12,1.12,0,0,0-.48.46,1.33,1.33,0,0,0-.17.69,1.31,1.31,0,0,0,.17.69,1.18,1.18,0,0,0,.47.47,1.48,1.48,0,0,0,.7.17,1.53,1.53,0,0,0,.74-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.22,109.45H93.3l-.37.88H92l1.84-4.13h.94l1.85,4.13h-1Zm-.3-.73-.66-1.58-.65,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.65,110.33l-.8-1.15H98v1.15H97V106.2h1.79a2.33,2.33,0,0,1,1,.18,1.39,1.39,0,0,1,.62.52,1.41,1.41,0,0,1,.22.8,1.38,1.38,0,0,1-.22.79,1.46,1.46,0,0,1-.63.51l.93,1.33Zm-.24-3.17a1,1,0,0,0-.66-.18H98v1.44h.78a1,1,0,0,0,.66-.19.65.65,0,0,0,.22-.53A.67.67,0,0,0,99.41,107.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsMobile);
export default __webpack_public_path__ + "static/media/tools-mobile.c4333a8c47c3483631b6cdd9b020050f.svg";
export { ForwardRef as ReactComponent };